// Jquery
window.$ = window.jQuery = require('jquery');

// SweetAlert
window.swal = require('sweetalert')

// Iconos
require("./vendor/js/iconify");

// Owl Carousel
require("owl.carousel");
